import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";
export const FORGOT_PASSWORD = 'forgot_password';
export const RESET_PASSWORD = 'reset_password';
// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
export const CHECK_TOKEN="checkToken";

const state = {
  errors: null,
  user: {},
  currentTenant: null,
  callVerified: 0,
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  setCallVerified(){
    return state.callVerified;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("auth/login-verify", credentials)
        .then(({ data }) => {
          if (data.data.token) {
            data.data.user.token = data.data.token;
            context.commit("resetAntMenu");
            context.commit(SET_AUTH, data.data);
            ApiService.setHeader();
            context
              .dispatch("getAntMenuList")
              .then(() => resolve(data))
              .catch(reject);
            return;
          }
          resolve(data);
        })
        .catch((response) => {
          context.commit(SET_ERROR, response);
          reject(response);
        });
    });
  },
  [LOGOUT](context) {
    return new Promise((resolve, reject) => {
      ApiService.post("auth/logout")
        .then(({ data }) => {
          context.commit(PURGE_AUTH);
          context.commit("resetAntMenu");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(PURGE_AUTH);
          context.commit("resetAntMenu");
          context.commit(SET_ERROR, response);
          reject(response);
        });
    });
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return new Promise((resolve, reject) => {
        ApiService.get("auth/verify")
          .then(({ data }) => {
            data.data.user.token = data.data.token;
            context.commit(SET_AUTH, data.data);
            const fetchAntMenu = context.rootState.antMenu.antMenuLoaded
              ? Promise.resolve()
              : context.dispatch("getAntMenuList");
            fetchAntMenu.then(() => resolve(data)).catch(reject);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response);
            reject(response);
          });
      });
    }

    context.commit(PURGE_AUTH);
    context.commit("resetAntMenu");
    return Promise.resolve();
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  },
  async [FORGOT_PASSWORD](context,payload){
    const data = payload
    return new Promise(resolve => {
      ApiService.post("auth/forgot-password", data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response);
          });
    });

  },

  [RESET_PASSWORD](context,payload){
    const data = payload
    return new Promise(resolve => {
      ApiService.post("auth/reset-password", data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response);
          });
    });

  },
  async [CHECK_TOKEN](context, data) {
    try {
      return await ApiService
          .post(`/auth/check-token`, {token:data});
    } catch (e) {
      if (e.response.data.status == ERROR_SERVER) {
        return  e.response.data.message
      } else {
        throw e;
      }
    }
  }


};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, payload) {
    const incomingUser = payload.user || {};
    const mergedRole = {
      ...(state.user.role || {}),
      ...(incomingUser.role || {}),
    };
    const permissionPreset =
      incomingUser.permission_preset ??
      mergedRole.permission_preset ??
      state.user.permission_preset;

    state.isAuthenticated = true;
    state.user = {
      ...state.user,
      ...incomingUser,
      permission_preset: permissionPreset,
      role: {
        ...mergedRole,
        permission_preset: permissionPreset ?? mergedRole.permission_preset,
      },
      token: incomingUser.token || state.user.token,
    };
    state.errors = {};
    JwtService.saveToken(state.user.token);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
